export type BefehlGrundDialogData = {
  nr: string
  anlass: string
  kmh: string
}

export const grundList: BefehlGrundDialogData[] = [
  {
    nr: '10',
    anlass: 'Gleis kann besetzt sein',
    kmh: 'FaS'
  },
  {
    nr: '11',
    anlass: 'Personen im Gleis / Kinder am Gleis',
    kmh: 'FaS'
  },
  {
    nr: '12',
    anlass: 'Fahrzeuge im Gleis',
    kmh: 'FaS'
  },
  {
    nr: '13',
    anlass: 'Mehrere Sperrfahrten unterwegs',
    kmh: 'FaS'
  },
  {
    nr: '14',
    anlass: 'Einfahrt in ein Stumpfgleis',
    kmh: '30'
  },
  {
    nr: '15',
    anlass:
      'Einfahrt in ein teilweise besetztes Gleis, nur teilweise befahrbares Gleis oder besonders kurzes Stumpfgleis',
    kmh: '20'
  },
  {
    nr: '16',
    anlass: 'Kein Durchrutschweg',
    kmh: '30'
  },
  {
    nr: '17',
    anlass: 'Auf der Strecke ruht die Arbeit',
    kmh: '50'
  },
  {
    nr: '18',
    anlass: 'Reisezug muss ausnahmsweise über Güterzuggleise fahren',
    kmh: '40'
  },
  {
    nr: '19',
    anlass: 'Bahnübergang nicht ausreichend gesichert',
    kmh: '20'
  },
  {
    nr: '20',
    anlass: 'Spurrillen nicht von Eis und Schnee befreit',
    kmh: '30'
  },
  {
    nr: '21',
    anlass: 'Reisendenübergang nicht gesichert',
    kmh: '5'
  },
  {
    nr: '22',
    anlass: 'Bauarbeiten',
    kmh: ')*'
  },
  {
    nr: '23',
    anlass: 'Unbefahrbare Stelle im gesperrten Gleis',
    kmh: 'FaS'
  },
  {
    nr: '24',
    anlass: 'Zustand nach Bauarbeiten',
    kmh: ')*'
  },
  {
    nr: '25',
    anlass: 'Arbeitsstelle nicht benachrichtigt',
    kmh: 'FaS'
  },
  {
    nr: '26',
    anlass: 'Niedrigere Geschwindigkeit gegenüber der La',
    kmh: ')*'
  },
  {
    nr: '27',
    anlass: 'Beschäftigte im gesperrten Gleis',
    kmh: '20 FaS'
  },
  {
    nr: '28',
    anlass: 'Verdacht auf Mängel am Oberbau',
    kmh: '25 FaS'
  },
  {
    nr: '29',
    anlass: 'Mängel am Oberbau',
    kmh: ')*'
  },
  {
    nr: '30',
    anlass: 'Verdacht auf Oberleitungsschäden (auch im benachbarten Gleis)',
    kmh: 'FaS'
  },
  {
    nr: '31',
    anlass: 'Verdacht auf Unwetterschäden (Erdrutsch, Sturmschäden etc.)',
    kmh: 'FaS'
  },
  {
    nr: '32',
    anlass: 'Verdacht auf Eiszapfen im Tunnel',
    kmh: 'FaS'
  },
  {
    nr: '33',
    anlass: 'PZB-Streckeneinrichtung gestört (gilt nicht bei Anzeigeführung)',
    kmh: '50'
  },
  {
    nr: '34',
    anlass: 'Weichen außer Abhängigkeit von Signalen',
    kmh: '50'
  },
  {
    nr: '35',
    anlass: 'Weiche mit HV 73 ohne Sperrvorrichtung gesichert',
    kmh: '5'
  },
  {
    nr: '36',
    anlass: 'Heißläuferortungsanlage / Festbremsortungsanlage gestört',
    kmh: '200'
  },
  {
    nr: '37',
    anlass: 'Warnung von Reisenden auf Bahnsteigen nicht möglich',
    kmh: ')*'
  },
  {
    nr: '38',
    anlass: 'Reisende nicht über Bahnsteigänderung informiert',
    kmh: 'FaS'
  },
  {
    nr: '39',
    anlass: 'Engstelle für Lü-Sendungen',
    kmh: '10'
  },
  {
    nr: '40',
    anlass: 'Eingeschränkte Tragfähigkeit der Bahnanlagen bei Schwerwagen',
    kmh: ')*'
  },
  {
    nr: '41',
    anlass: 'Spitzensignal unvollständig',
    kmh: '40'
  },
  {
    nr: '42',
    anlass: 'Windwarnung',
    kmh: '80'
  },
  {
    nr: '43',
    anlass: 'Schwungfahrabschnitt',
    kmh: '140'
  }
]
